import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const EnterEvent: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M10.1719 19.1772L16.1719 12.8915C16.6125 12.4299 16.6125 11.6834 16.1719 11.2267L10.1719 4.9361C9.73125 4.4745 9.01875 4.4745 8.58281 4.9361C8.14688 5.39771 8.14219 6.14414 8.58281 6.60084L12.6609 10.8732L1.125 10.8781C0.501562 10.8781 0 11.4035 0 12.0566C0 12.7098 0.501562 13.2352 1.125 13.2352H12.6609L8.58281 17.5075C8.14219 17.9691 8.14219 18.7156 8.58281 19.1723C9.02344 19.629 9.73594 19.6339 10.1719 19.1723V19.1772ZM16.125 3.41378H19.875C20.9109 3.41378 21.75 4.2928 21.75 5.37807V18.7352C21.75 19.8205 20.9109 20.6995 19.875 20.6995H16.125C15.5016 20.6995 15 21.2249 15 21.8781C15 22.5312 15.5016 23.0566 16.125 23.0566H19.875C22.1531 23.0566 24 21.1218 24 18.7352V5.37807C24 2.99146 22.1531 1.05664 19.875 1.05664H16.125C15.5016 1.05664 15 1.58209 15 2.23521C15 2.88834 15.5016 3.41378 16.125 3.41378Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default EnterEvent
